/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetNotificationsResponse } from '../../models/get-notifications-response';

export interface NotificationServiceGetNotifications$Params {
  userUuid: string;
  discordId?: string;

/**
 * Include acknowledged in created_at time order.
 */
  includeAcknowledged?: boolean;

/**
 * Include acknowledged, but only ~5 and below the unread notifications
 */
  includeAcknowledgedNearUnread?: boolean;
}

export function notificationServiceGetNotifications(http: HttpClient, rootUrl: string, params: NotificationServiceGetNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNotificationsResponse>> {
  const rb = new RequestBuilder(rootUrl, notificationServiceGetNotifications.PATH, 'get');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.query('discordId', params.discordId, {});
    rb.query('includeAcknowledged', params.includeAcknowledged, {});
    rb.query('includeAcknowledgedNearUnread', params.includeAcknowledgedNearUnread, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetNotificationsResponse>;
    })
  );
}

notificationServiceGetNotifications.PATH = '/api/v3/gateway/user/{userUuid}/notifications';
